import { Layer, ThemeContext } from 'grommet';
import { Monitor, X } from 'lucide-preact';
import { useDispatch } from 'react-redux';

import { useSelector } from '@/redux/helper';
import { dismissMobileWarning } from '@/redux/slices/guidedTour/actions';

// Only rendered by GuidedTourOrchestrator when already confirmed to be on mobile.
const MobileWarningModal = () => {
  const dispatch = useDispatch();
  const isCompleted = useSelector((state) => state.guidedTour.isCompleted);
  const mobileWarningDismissed = useSelector((state) => state.guidedTour.mobileWarningDismissed);

  if (isCompleted || mobileWarningDismissed) return null;

  const handleDismiss = () => dispatch(dismissMobileWarning());

  return (
    <ThemeContext.Extend
      value={{
        layer: {
          zIndex: '1000',
          container: { zIndex: '1001' },
        },
      }}
    >
      <Layer
        className="w-[80vw] max-w-[384px] !rounded-2xl"
        onEsc={handleDismiss}
        onClickOutside={handleDismiss}
        aria-labelledby="mobile-warning-title"
      >
        <div className="preflight relative rounded-2xl bg-white p-6">
          <button
            type="button"
            onClick={handleDismiss}
            aria-label="Close"
            className="preflight preflight-button absolute right-3 top-3 text-grey-1"
          >
            <X className="preflight size-5" />
          </button>

          <div className="preflight mx-auto flex max-w-[260px] flex-col items-center text-center">
            <Monitor className="preflight size-8 text-black" />
            <h2 id="mobile-warning-title" className="preflight preflight-h2 mt-3 text-[17px] font-bold leading-5 text-black">
              Your All-Access Tour is Ready for you on Desktop!
            </h2>
            <p className="preflight preflight-p mt-4 text-sm font-bold leading-5 text-[#6c6c6c]">
              This tour is not compatible with this device. Please use zoolife on a bigger screen to experience the habitats
              in full detail.
            </p>
            <p className="preflight preflight-p mt-10 text-sm leading-5 text-[#6c6c6c]">
              If you&rsquo;re having any issues, please{' '}
              <a href="mailto:support@zoolife.tv" className="preflight preflight-a font-semibold text-black underline">
                contact us.
              </a>
            </p>
          </div>
        </div>
      </Layer>
    </ThemeContext.Extend>
  );
};

export default MobileWarningModal;
